import moment from 'moment-timezone'
import { Daycare } from '@/types/Daycare'
import { OccasionalSlot } from '@/types/Slots'
import { getDaycareClosing, getDaycareOpening } from '@/modules/helper/daycareHelper'
import { HOUR_MINUTE_FORMAT } from '../../models/constants'
import { momentDay } from '../../models/common'
import { OccasionalSlotFormProps } from '../types'

interface OpeningAndClosingTime {
    openingTime: string
    closingTime: string
}

const DEFAULT_OPENING_TIME: string = '08:00'
const DEFAULT_CLOSING_TIME: string = '17:30'

// Slot times come from the API as 'HH:mm:ss'
function toHourMinute(time: string): string {
    return moment(time, 'HH:mm:ss').format(HOUR_MINUTE_FORMAT)
}

export default function getInitialOpeningAndClosingTime(
    props: OccasionalSlotFormProps,
    currentDaycare: Daycare
): OpeningAndClosingTime {
    switch (props.type) {
        case 'add': {
            // Opening hours are indexed from Monday (0) to Sunday (6)
            const day: number = momentDay(props.selectedDate).isoWeekday() - 1

            return {
                openingTime: getDaycareOpening(currentDaycare, day) || DEFAULT_OPENING_TIME,
                closingTime: getDaycareClosing(currentDaycare, day) || DEFAULT_CLOSING_TIME
            }
        }

        case 'edit': {
            return {
                openingTime: toHourMinute(props.occasionalSlot.start),
                closingTime: toHourMinute(props.occasionalSlot.end)
            }
        }

        case 'multiEdit': {
            const referenceSlot: OccasionalSlot = props.occasionalSlots[0]

            return {
                openingTime: toHourMinute(referenceSlot.start),
                closingTime: toHourMinute(referenceSlot.end)
            }
        }
    }
}
